import React from 'react';
import styles from './ScanQrChecker.module.css';
import { useHistory } from 'react-router-dom';
import InvalidIcon from '../icons/InvalidIcon';
import CloseIconChecker from '../icons/CloseIconChecker';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//renderizar dependiendo si es un error del show o q el ticket no es de ese show poner ticketr invalido

const ScanQrCheckerError = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(location.search);
  const referenceCode = queryParams.get('referenceCode');
  const showName = queryParams.get('showName');
  const id = queryParams.get('id');
  const errorType = queryParams.get('errorType');
  const codeTicket = queryParams.get('codeTicket');
  return (
    <div className={styles.paymentError}>
      <div
        className={styles.crossIcon}
        onClick={() =>
          history.push({
            pathname: `/scan-qr-checker/${id}`,
          })
        }
        style={{ cursor: 'pointer', position: 'absolute', top: 30, left: 30, fontSize: '30px' }}
      >
        <CloseIconChecker size={'30px'} color={'#FFF'}></CloseIconChecker>
      </div>

      <div className={styles.successIcon}>
        <div className={styles.circle}>
          <div>
            <InvalidIcon></InvalidIcon>
          </div>
        </div>
      </div>

      <div className='container mx-1 '>
        <div className={`font-large bold  ${styles.validTitle}`}>{t('checkShow.notValid')}</div>
        <div className='font-medium mt-3 lh-title'>
          e-ticket
          {errorType !== 'INVALID_EVENT'
            ? t('checkShow.alreadyUsed')
            : t('checkShow.invalidTicket')}
        </div>

        {errorType !== 'INVALID_EVENT' && (
          <>
            <div className='mt-4'>
              <div>
                <div className='font-tiny'>Ticket</div>
                <div
                  className={`d-flex justify-content-between align-items-center ${styles.containerBorder}`}
                >
                  <div className='font-normal bold'>{showName}</div>
                </div>
              </div>
            </div>
            <div className='mt-2 font-tiny'>ID TICKET </div>
            <div className=' font-tiny'>#{codeTicket}</div>
          </>
        )}

        <div className='d-flex justify-content-end pt-4 pb-5'>
          <div
            className={`font-normal bold ${styles.button} ${styles.buttonBorderInvalid}`}
            onClick={() =>
              history.push({
                pathname: `/scan-qr-checker/${id}`,
              })
            }
          >
            {t('checkShow.following')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanQrCheckerError;
